import {NgModule} from '@angular/core';

import {LayoutComponent} from './layout.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {HeaderComponent} from './header/header.component';
import {OffsidebarComponent} from './offsidebar/offsidebar.component';
import {UserblockComponent} from './sidebar/userblock/userblock.component';
import {UserblockService} from './sidebar/userblock/userblock.service';
import {FooterComponent} from './footer/footer.component';
import {SpinnerComponent} from './spinner/spinner.component';

import {SharedModule} from '../shared/shared.module';
import {SharedMaterialModule} from '../shared/shared-material.module';

@NgModule({
  imports: [
    SharedModule,
    SharedMaterialModule
  ],
  providers: [
    UserblockService
  ],
  declarations: [
    LayoutComponent,
    SidebarComponent,
    UserblockComponent,
    HeaderComponent,
    OffsidebarComponent,
    FooterComponent,
    SpinnerComponent
  ],
  exports: [
    LayoutComponent,
    SidebarComponent,
    UserblockComponent,
    HeaderComponent,
    OffsidebarComponent,
    FooterComponent
  ]
})
export class LayoutModule {
}
